import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-clapboard",
  "use": "icon-si-glyph-clapboard-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-clapboard\" id=\"icon-si-glyph-clapboard\"><title>818</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 0.000000)\" fill=\"#434343\"><path d=\"M1.042,7.954 L15.958,4.431 L14.978,0.375 L0.063,3.898 L1.042,7.954 L1.042,7.954 Z M12.55,4.357 L11.102,2.045 L13.112,1.559 L14.561,3.871 L12.55,4.357 L12.55,4.357 Z M9.199,5.167 L7.75,2.855 L9.759,2.37 L11.209,4.682 L9.199,5.167 L9.199,5.167 Z M5.848,5.977 L4.4,3.665 L6.41,3.18 L7.859,5.492 L5.848,5.977 L5.848,5.977 Z M2.498,6.787 L1.049,4.475 L3.058,3.99 L4.507,6.302 L2.498,6.787 L2.498,6.787 Z\" class=\"si-glyph-fill\" /><path d=\"M1.021,8.037 L16,8.037 L16,15.987 L1.021,15.987 L1.021,8.037 L1.021,8.037 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-clapboard.svg
// module id = 4e3t
// module chunks = 62